import { techTips } from '@/mocks/content';

export default function TipsSection() {
  return (
    <section id="tips" className="w-full scroll-mt-20 bg-amber-50 py-14 md:py-20 border-y border-stone-200">
      <div className="w-full px-4 md:px-8">
        <div className="relative rounded-2xl overflow-hidden w-full h-40 md:h-56 mb-10">
          <img
            src="https://readdy.ai/api/search-image?query=Wide%20abstract%20banner%20in%20warm%20peach%20orange%20and%20cream%20tones%2C%20soft%20light%20rays%20and%20gentle%20film%20grain%20texture%2C%20flowing%20smooth%20gradient%20shapes%2C%20minimal%20elegant%20artistic%20background%2C%20no%20text&width=1600&height=560&seq=peach-banner-01&orientation=landscape"
            alt="暖调蜜桃色抽象横幅背景"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-stone-900/70 via-stone-900/40 to-transparent"></div>
          <div className="absolute inset-0 flex flex-col justify-center px-6 md:px-10">
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-white">画质、字幕与播放体验</h2>
            <p className="mt-2 text-sm md:text-base text-white/85 max-w-xl">
              同样一部片子，看得清不清楚、听不听得到原声，往往就差在这几个细节上。
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {techTips.map((tip) => (
            <article key={tip.title} className="bg-white border border-stone-200 rounded-xl p-6">
              <div className="flex items-center gap-3">
                <span className="w-11 h-11 flex items-center justify-center rounded-lg bg-stone-100 text-stone-700">
                  <i className={`${tip.icon} text-xl`} aria-hidden="true"></i>
                </span>
                <h3 className="font-heading text-lg font-semibold text-stone-900">{tip.title}</h3>
              </div>
              <ul className="mt-4 space-y-3">
                {tip.points.map((p) => (
                  <li key={p} className="flex items-start gap-2 text-sm text-stone-600 leading-relaxed">
                    <i className="ri-lightbulb-line text-amber-500 mt-0.5" aria-hidden="true"></i>
                    <span>{p}</span>
                  </li>
                ))}
              </ul>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}